export default [
  'subscription-form',
  'subscription-page',
  'subscription-success',
  'plans',
  'common',
  'dashboard',
  'login',
] as const;
